import { storage } from '@digital/ui';

import { getJwtPayload } from '.././helpers';

export const hasPermission = (permissions: string[]) => {
  let userPermissions = storage.getPermissions();
  if (userPermissions.some(p1 => permissions.some(p2 => p2 == p1))) return true;
  return false;
};

export const hasPermissionPerfil = (perfis: string[]) => {
  var payload = getJwtPayload();
  if (payload && payload.perfis) {
    if (typeof payload.perfis === 'string') {
      return perfis.some(p1 => p1 == payload.perfis);
    }

    const perfisJwt = payload.perfis.length > 0 ? payload.perfis : [];
    if (perfisJwt.some(p1 => perfis.some(p2 => p2 == p1))) return true;
  }
  return false;
};
